import React from "react";
import { styled, Container, Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import { Alert, AlertTitle } from "@material-ui/lab";
import WTWLogo from "../wtw-logo.svg";

const AreaContainer = styled("div")({
  margin: "1rem 0",
});

const Header = () => {
  return (
    <AreaContainer>
          <img alt="WTW Logo" src={WTWLogo}></img>
    </AreaContainer>
  );
};

export const PartnerError = () => {
  return (
    <Container>
      <Grid container justify="center">
        <Grid item xs={12} sm={8}>
          <Header/>
          <AreaContainer>
            <Alert severity="error">
              <AlertTitle>Ett fel har inträffat</AlertTitle>
              Vi kunde inte hantera det data som du skickade, gå tillbaka och se vad som gick fel!
            </Alert>
          </AreaContainer>
          <AreaContainer>
            <Button variant='contained' color='primary' onClick={() => window.history.back()}>Gå tillbaka ...</Button>
          </AreaContainer>
        </Grid>
      </Grid>
    </Container>
  );
};
